import { useMutation, useQueryClient } from '@tanstack/react-query';

import { PositionFormData } from 'components/PositionModal/types';
import getClient from 'apiTyped/client';

/**
 * Saves the user's position profile data via PATCH /users/me/position.
 */
export const useSaveUserPosition = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: PositionFormData) => {
      const client = await getClient();
      const response = await (client as any).PATCH('/users/me/position', {
        body: {
          position_id: data.position_id,
          position_title: data.position_title
        }
      });
      if (response.error) throw new Error(String(response.error));
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['/users/me']
      });
    }
  });
};
